module.exports = {
  DEFAULT: 'default',
  SLOTS: 'slots'
}
